export function isIdleReserveMachine(machine) {
  if (!machine) return false;
  const status = machine.registration_status;
  if (status === "reserve_available") return true;
  if (status === "reserve_in_use" || status === "pending_registration") {
    return false;
  }
  const ident = String(machine.ident || "")
    .trim()
    .toUpperCase();
  return (
    ident === "RESERVA" ||
    ident.startsWith("RESERVA-") ||
    ident.startsWith("RESERVA ")
  );
}

export function isPendingMachineRegistration(machine) {
  if (!machine) return false;
  return (
    machine.registration_status === "pending_registration" ||
    machine.registration_status === "reserve_in_use"
  );
}

export function visibleMachinesForWeb(machines) {
  return (machines || []).filter((machine) => !isIdleReserveMachine(machine));
}

export function sortMachinesPendingFirst(machines) {
  return (machines || []).slice().sort((left, right) => {
    const leftPending = isPendingMachineRegistration(left) ? 1 : 0;
    const rightPending = isPendingMachineRegistration(right) ? 1 : 0;
    return rightPending - leftPending;
  });
}
